export default __webpack_public_path__ + "static/media/catWindow.9ab8e6ad.png";